import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleEmpty: {
		id: 'software-cycle-time-breakdown-report.issue-chart.title-empty',
		defaultMessage: 'No week median',
		description: 'Title of a chart when there is no data.',
	},
	moreDataRequired: {
		id: 'software-cycle-time-breakdown-report.issue-chart.more-data-required',
		defaultMessage: 'more data required',
		description: 'Display when data is empty indicating user has no data to show the graph',
	},
	numIssuesShippedLimitedPermissions: {
		id: 'software-cycle-time-breakdown-report.issue-chart.num-issues-shipped-limited-permissions',
		defaultMessage:
			'Showing {numIssuesShipped} {numIssuesShipped, plural, one {issue} other {issues}} shipped to production',
		description: 'label for number of commits done during development phase',
	},
	numIssuesShippedLimitedPermissionsIssueTermRefresh: {
		id: 'software-cycle-time-breakdown-report.issue-chart.num-issues-shipped-limited-permissions-issue-term-refresh',
		defaultMessage:
			'Showing {numIssuesShipped} {numIssuesShipped, plural, one {work item} other {work items}} shipped to production',
		description: 'label for number of commits done during development phase',
	},
	numIssuesShipped: {
		id: 'software-cycle-time-breakdown-report.issue-chart.num-issues-shipped',
		defaultMessage:
			'{numIssuesShipped} {numIssuesShipped, plural, one {issue} other {issues}} shipped to production',
		description: 'label for number of commits done during development phase',
	},
	numIssuesShippedIssueTermRefresh: {
		id: 'software-cycle-time-breakdown-report.issue-chart.num-issues-shipped-issue-term-refresh',
		defaultMessage:
			'{numIssuesShipped} {numIssuesShipped, plural, one {work item} other {work items}} shipped to production',
		description: 'label for number of commits done during development phase',
	},
	issue: {
		id: 'software-cycle-time-breakdown-report.issue-chart.issue',
		defaultMessage: 'Issue',
		description: 'Label in a legend. issue refers to Jira Issues plotted on a graph.',
	},
	issueIssueTermRefresh: {
		id: 'software-cycle-time-breakdown-report.issue-chart.issue-issue-term-refresh',
		defaultMessage: 'Work item',
		description: 'Label in a legend. issue refers to Jira Issues plotted on a graph.',
	},
	twelveWeekMedian: {
		id: 'software-cycle-time-breakdown-report.issue-chart.twelve-week-median',
		defaultMessage: '12-week median',
		description:
			'Label in a legend. Represents the median issue cycle time over the past 12 weeks.',
	},
	noPermissions: {
		id: 'software-cycle-time-breakdown-report.issue-chart.no-permissions',
		defaultMessage:
			'Unable to view issues, contact admin for the permissions or change the selected week.',
		description: 'Message explaining where there are no results on the chart',
	},
	noPermissionsIssueTermRefresh: {
		id: 'software-cycle-time-breakdown-report.issue-chart.no-permissions-issue-term-refresh',
		defaultMessage:
			'Unable to view work items, contact admin for the permissions or change the selected week.',
		description: 'Message explaining where there are no results on the chart',
	},
	numIssuesTooltip: {
		id: 'software-cycle-time-breakdown-report.issue-chart.num-issues-tooltip',
		defaultMessage: 'Not all issues are shown here due to permissions, contact admin for more.',
		description: 'Tooltip explaining why not all issues are shown on the chart.',
	},
	numIssuesTooltipIssueTermRefresh: {
		id: 'software-cycle-time-breakdown-report.issue-chart.num-issues-tooltip-issue-term-refresh',
		defaultMessage: 'Not all work items are shown here due to permissions, contact admin for more.',
		description: 'Tooltip explaining why not all issues are shown on the chart.',
	},
});
